import api from '@/api';
import { API_BASE_URL } from '..';
import { CertificateCreateRequest } from './AgreementCertiifcate.types';

const CONTROLLER_URL = `${API_BASE_URL}/agreementCertificate`;

export async function createCertificateAgreement(
  obj: CertificateCreateRequest,
) {
  const formData = new FormData();

  for (const key in obj) {
    formData.append(key, obj[key as keyof typeof obj]);
  }

  const result = (await api.post(`${CONTROLLER_URL}`, formData, null, {
    contentType: 'multpart/form-data',
  })) as unknown;

  return result;
}

export async function deleteCertificateAgreement(bankAccountId: number) {
  const result = (await api.remove(
    `${CONTROLLER_URL}/${bankAccountId}`,
    {},
    null,
  )) as unknown;

  return result;
}
